import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Template from "./template";

const dataQuery = graphql`
  query {
    homeJson {
      latestRelease {
        title
        image {
          src {
            publicURL
          }
          alt
        }
        cta1_label
        cta1_link
        cta2_label
        cta2_link
      }
    }
  }
`;

function LatestRelease() {
  const {
    homeJson: { latestRelease }
  } = useStaticQuery(dataQuery);

  return <Template data={latestRelease} />;
}

export default LatestRelease;
